module.exports = __webpack_public_path__ + "static/media/keepapiLogo.4255596a.png";